import { ModelHelper } from '../classes/model-helper';

/**
 * Signature file data
 */
export class SignatureFileData {
	filePath: string;
	storageFileNumber: number;
	uid: string;

	/**
	 * Static mapping function
	 *
	 * @param data
	 * @param item
	 * @returns SignatureFileData
	 */
	static map(data: any, item: SignatureFileData = new SignatureFileData()): SignatureFileData {
		return item.map(data);
	}

	/**
	 * Non static mapping function
	 *
	 * @param data
	 * @return SignatureFileData
	 */
	public map(data: any): SignatureFileData {
		ModelHelper.map(data, this, 'filePath');
		ModelHelper.map(data, this, 'storageFileNumber');
		ModelHelper.map(data, this, 'uid');

		return this;
	}

	/**
	 * Prepare company data for api
	 *
	 * @param data
	 */
	public getDataForApi(data: any = this): any {
		return this.uid;
	}
}
